import styled from 'styled-components'

export const ChartContainer = styled.div`
  width: 100%;
  border-bottom: 0.063em solid rgba(192, 192, 192, 0.3);
  padding: 0.313em;
  cursor: pointer;
`

export const ChartHeader = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: white;
  font-size: 0.75em;
  color: ${props => props.theme};
  padding: 0.313em;
  margin-top: 0.313em;
  margin-bottom: 0.313em;
  cursor: pointer;
`

export const Span = styled.span`
  font-weight: bold;
  margin-left: 0.313em;
  margin-right: 0.125em;
  text-transform: capitalize;
  color: #34495e;
`

export const ClearFilter = styled.div`
  width: 40%;
  background-color: ${props => props.theme};
  color: white;
  font-size: 0.75em;
  font-weight: bold;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-right: 0.063em;
  padding-left: 0.063em;
  cursor: pointer;
  border-radius: 0.313em;
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
  & svg {
    height: 1.563em;
    width: 1.563em;
  }
`



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/styles/SubTypeChart.js